import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import application from './application';
import territories from './territories';
import coordinations from './coordinations'; 
import home from './home';
import users from './users';  
import session from './session';
import clients from './clients';
import uploads from './uploads';
import reports from './reports';
import support from './support';
import communiques from './communiques';

const rootReducer = combineReducers({
    application,
    territories,
    coordinations,
    home,
    users,
    clients,
    session,
    uploads,
    reports,
    support,
    communiques,
    routing  : routerReducer
});

export default rootReducer;


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/